import UseCase from "./marketing/UseCase";

export default function UseCaseRealEstate() {
  return (
    <UseCase
      path="/for/real-estate"
      seoTitle="NFC business cards for real estate agents — WhoBrew"
      seoDescription="A digital business card for realtors, brokers, and showing agents. Listings, tours, sign-in QR for open houses, and lead capture in one link."
      eyebrow="For real estate"
      headline="Listings, tours, and contact in one link."
      italicWord="link"
      subhead="Replace the stack of yard-sign cards in your trunk. One link carries your active listings, your Matterport tours, your Zillow profile, and a sign-in QR for every open house you run."
      preview={{ name: "Sean Thomas", title: "Realtor", handle: "seanthomas" }}
      linkExamples={[
        { label: "Active listings" },
        { label: "Zillow profile" },
        { label: "Matterport tours" },
        { label: "Open-house sign-in" },
        { label: "Schedule a tour" },
        { label: "Mortgage calculator" },
        { label: "Neighborhood guide" },
        { label: "Apple Wallet" },
      ]}
      features={[
        {
          title: "An open-house sign-in that actually captures leads.",
          body: "Print one QR code for every open house. Visitors scan it from the table, drop their name and email, and your follow-up sequence starts the same evening.",
        },
        {
          title: "Always-current listings.",
          body: "Link to your live MLS feed or Zillow profile. The buyer who opens your card today sees the listings you have today, not the ones you printed last quarter.",
        },
        {
          title: "Tour scheduling without the call.",
          body: "Embed your Calendly so a buyer can book a showing in two clicks. The card replaces the tag-team back-and-forth of voicemail-text-email.",
        },
      ]}
      steps={[
        {
          title: "Set up your card with your listings and Zillow profile.",
          body: "Drop in your active listings link, your Zillow profile, your Matterport tours, and your contact form. Two minutes from sign-up to live.",
        },
        {
          title: "Print the QR on every yard sign and open-house flyer.",
          body: "Generate a print-ready QR code. Add it to yard signs, brochures, and your for-sale-by-owner table tents. Every passerby is a scan away from your full portfolio.",
        },
        {
          title: "Watch leads land in your inbox.",
          body: "Open-house sign-ins, listing inquiries, and tour requests all land in your Leads tab, source-tagged so you know which property drove the conversation.",
        },
      ]}
      faq={[
        {
          q: "Does this work with my MLS or brokerage's tools?",
          a: "Yes. WhoBrew links to anything your MLS already exposes publicly — your listings page, your Zillow profile, your IDX feed. You don't need new tools.",
        },
        {
          q: "Can I have a different card per listing?",
          a: "Pro accounts get up to three cards. Most agents use one main card and create a second one for premium listings, with the listing-specific tour as the primary CTA.",
        },
        {
          q: "What about my brokerage's branding requirements?",
          a: "You control your card's colors, logo, and accent. Most brokerages allow agents to use their own digital business card alongside the firm's branding, just as they would a personal LinkedIn profile.",
        },
        {
          q: "Is the open-house QR really a fit for capturing leads?",
          a: "Visitors who fill out a digital form on their own phone are dramatically more likely to leave real contact info than visitors writing on a clipboard. The form lives on your WhoBrew card and can be set to require email before sharing your full contact.",
        },
        {
          q: "Can I send leads to my CRM?",
          a: "Yes. Export leads as CSV, ready to import into Follow Up Boss, kvCORE, or any other real estate CRM. Direct integrations are on the roadmap.",
        },
      ]}
    />
  );
}
